// # Define an array of Quran juz' videos with their YouTube links
export const quranVideos = [
  {
    id: 1,
    title: "Juz' 1",
    description: "Al-Fatiha and beginning of Al-Baqarah",
    videoUrl: "https://www.youtube.com/embed/sOui0-NV7AA?autoplay=1",
    thumbnailUrl: `https://img.youtube.com/vi/sOui0-NV7AA/maxresdefault.jpg`
  },
  {
    id: 2,
    title: "Juz' 2",
    description: "Al-Baqarah",
    videoUrl: "https://www.youtube.com/embed/GDZKChtGiUg?autoplay=1",
    thumbnailUrl: `https://img.youtube.com/vi/GDZKChtGiUg/maxresdefault.jpg`
  },
  {
    id: 3,
    title: "Juz' 3",
    description: "Al-Imran",
    videoUrl: "https://www.youtube.com/embed/n_Aj41RX4Go?autoplay=1",
    thumbnailUrl: `https://img.youtube.com/vi/n_Aj41RX4Go/maxresdefault.jpg`
  },
  {
    id: 4,
    title: "Juz' 4",
    description: "An-Nisa",
    videoUrl: "https://www.youtube.com/embed/sFr4RaqF1wY?autoplay=1",
    thumbnailUrl: `https://img.youtube.com/vi/sFr4RaqF1wY/maxresdefault.jpg`
  },
  {
    id: 5,
    title: "Juz' 5",
    description: "Al-Ma'idah",
    videoUrl: "https://www.youtube.com/embed/lM_Fyx8Z6yA?autoplay=1",
    thumbnailUrl: `https://img.youtube.com/vi/lM_Fyx8Z6yA/maxresdefault.jpg`
  },
  {
    id: 6,
    title: "Juz' 6",
    description: "Al-Anam",
    videoUrl: "https://www.youtube.com/embed/CCx0JStxABM?autoplay=1",
    thumbnailUrl: `https://img.youtube.com/vi/CCx0JStxABM/maxresdefault.jpg`
  },
  {
    id: 7,
    title: "Juz' 7",
    description: "Al-A'raf",
    videoUrl: "https://www.youtube.com/embed/86elPx6faLc?autoplay=1",
    thumbnailUrl: `https://img.youtube.com/vi/86elPx6faLc/maxresdefault.jpg`
  },
  {
    id: 8,
    title: "Juz' 8",
    description: "Al-Anfal",
    videoUrl: "https://www.youtube.com/embed/eaeuOPI0CYo?autoplay=1",
    thumbnailUrl: `https://img.youtube.com/vi/eaeuOPI0CYo/maxresdefault.jpg`
  },
  {
    id: 9,
    title: "Juz' 9",
    description: "At-Tawbah",
    videoUrl: "https://www.youtube.com/embed/1uEUbJcatYU?autoplay=1",
    thumbnailUrl: `https://img.youtube.com/vi/1uEUbJcatYU/maxresdefault.jpg`
  },
  {
    id: 10,
    title: "Juz' 10",
    description: "Al-Anfal and At-Tawbah",
    videoUrl: "https://www.youtube.com/embed/ZhDDrQ2-7aY?autoplay=1",
    thumbnailUrl: `https://img.youtube.com/vi/ZhDDrQ2-7aY/maxresdefault.jpg`
  },
  {
    id: 11,
    title: "Juz' 11",
    description: "At-Tawbah and Yunus",
    videoUrl: "https://www.youtube.com/embed/VX0fY5gjsG4?autoplay=1",
    thumbnailUrl: `https://img.youtube.com/vi/VX0fY5gjsG4/maxresdefault.jpg`
  },
  {
    id: 12,
    title: "Juz' 12",
    description: "Hud and Yusuf",
    videoUrl: "https://www.youtube.com/embed/f6LASO81PfA?autoplay=1",
    thumbnailUrl: `https://img.youtube.com/vi/f6LASO81PfA/maxresdefault.jpg`
  },
  {
    id: 13,
    title: "Juz' 13",
    description: "Ar-Ra'd and Ibrahim",
    videoUrl: "https://www.youtube.com/embed/WNG_OC-StZI?autoplay=1",
    thumbnailUrl: `https://img.youtube.com/vi/WNG_OC-StZI/maxresdefault.jpg`
  },
  {
    id: 14,
    title: "Juz' 14",
    description: "Al-Hijr and An-Nahl",
    videoUrl: "https://www.youtube.com/embed/81Hva77a_eo?autoplay=1",
    thumbnailUrl: `https://img.youtube.com/vi/81Hva77a_eo/maxresdefault.jpg`
  },
  {
    id: 15,
    title: "Juz' 15",
    description: "Al-Isra",
    videoUrl: "https://www.youtube.com/embed/N8RgQ60qelA?autoplay=1",
    thumbnailUrl: `https://img.youtube.com/vi/N8RgQ60qelA/maxresdefault.jpg`
  },
  {
    id: 16,
    title: "Juz' 16",
    description: "Al-Kahf",
    videoUrl: "https://www.youtube.com/embed/PgtywRoqt-Y?autoplay=1",
    thumbnailUrl: `https://img.youtube.com/vi/PgtywRoqt-Y/maxresdefault.jpg`
  },
  {
    id: 17,
    title: "Juz' 17",
    description: "Al-Anbiya and Al-Hajj",
    videoUrl: "https://www.youtube.com/embed/3mZKQwcFvTs?autoplay=1",
    thumbnailUrl: `https://img.youtube.com/vi/3mZKQwcFvTs/maxresdefault.jpg`
  },
  {
    id: 18,
    title: "Juz' 18",
    description: "Al-Mu'minun and An-Nur",
    videoUrl: "https://www.youtube.com/embed/ymCd_sUy3ZA?autoplay=1",
    thumbnailUrl: `https://img.youtube.com/vi/ymCd_sUy3ZA/maxresdefault.jpg`
  },
  {
    id: 19,
    title: "Juz' 19",
    description: "Al-Furqan and Ash-Shu'ara",
    videoUrl: "https://www.youtube.com/embed/_Oamv-8w4qo?autoplay=1",
    thumbnailUrl: `https://img.youtube.com/vi/_Oamv-8w4qo/maxresdefault.jpg`
  },
  {
    id: 20,
    title: "Juz' 20",
    description: "An-Naml and Al-Qasas",
    videoUrl: "https://www.youtube.com/embed/DHu_lLVnUNY?autoplay=1",
    thumbnailUrl: `https://img.youtube.com/vi/DHu_lLVnUNY/maxresdefault.jpg`
  },
  {
    id: 21,
    title: "Juz' 21",
    description: "Al-Ankabut and Ar-Rum",
    videoUrl: "https://www.youtube.com/embed/6v5WBr1rX0c?autoplay=1",
    thumbnailUrl: `https://img.youtube.com/vi/6v5WBr1rX0c/maxresdefault.jpg`
  },
  {
    id: 22,
    title: "Juz' 22",
    description: "Al-Ahzab",
    videoUrl: "https://www.youtube.com/embed/hwQ4PAWG2eM?autoplay=1",
    thumbnailUrl: `https://img.youtube.com/vi/hwQ4PAWG2eM/maxresdefault.jpg`
  },
  {
    id: 23,
    title: "Juz' 23",
    description: "Ya-Sin and As-Saffat",
    videoUrl: "https://www.youtube.com/embed/tXglDRFHxjw?autoplay=1",
    thumbnailUrl: `https://img.youtube.com/vi/tXglDRFHxjw/maxresdefault.jpg`
  },
  {
    id: 24,
    title: "Juz' 24",
    description: "Az-Zumar and Ghafir",
    videoUrl: "https://www.youtube.com/embed/6MyNR7DZtJM?autoplay=1",
    thumbnailUrl: `https://img.youtube.com/vi/6MyNR7DZtJM/maxresdefault.jpg`
  },
  {
    id: 25,
    title: "Juz' 25",
    description: "Fussilat and Al-Jathiyah",
    videoUrl: "https://www.youtube.com/embed/jtHtT-K8RGA?autoplay=1",
    thumbnailUrl: `https://img.youtube.com/vi/jtHtT-K8RGA/maxresdefault.jpg`
  },
  {
    id: 26,
    title: "Juz' 26",
    description: "Al-Ahqaf and Adh-Dhariyat",
    videoUrl: "https://www.youtube.com/embed/D5iDMbwaUIQ?autoplay=1",
    thumbnailUrl: `https://img.youtube.com/vi/D5iDMbwaUIQ/maxresdefault.jpg`
  },
  {
    id: 27,
    title: "Juz' 27",
    description: "Qaf and Al-Waqi'ah",
    videoUrl: "https://www.youtube.com/embed/G7lqEbYj-ag?autoplay=1",
    thumbnailUrl: `https://img.youtube.com/vi/G7lqEbYj-ag/maxresdefault.jpg`
  },
  {
    id: 28,
    title: "Juz' 28",
    description: "Al-Mujadilah and At-Tahrim",
    videoUrl: "https://www.youtube.com/embed/VKZbGgEMzHg?autoplay=1",
    thumbnailUrl: `https://img.youtube.com/vi/VKZbGgEMzHg/maxresdefault.jpg`
  },
  {
    id: 29,
    title: "Juz' 29",
    description: "Al-Mulk and Al-Mursalat",
    videoUrl: "https://www.youtube.com/embed/4QSRq8dECbQ?autoplay=1",
    thumbnailUrl: `https://img.youtube.com/vi/4QSRq8dECbQ/maxresdefault.jpg`
  },
  {
    id: 30,
    title: "Juz' 30",
    description: "An-Naba to An-Nas",
    videoUrl: "https://www.youtube.com/embed/2rxXmBY_TjU?autoplay=1",
    thumbnailUrl: `https://img.youtube.com/vi/2rxXmBY_TjU/maxresdefault.jpg`
  }
];
